<div class="lottie-animation-container" aria-hidden="true">
  <div class="wrapper" [class.circle]="circle">
    <div
      class="placeholder"
      *ngIf="animationLoading || animationError || animationLoopCompleted"
      [style.background-image]="imagePlaceholder"></div>
    <div class="animation" *ngIf="switch === 'A'">
      <ng-lottie
        *ngIf="lottieOptions"
        class="lottie-animation"
        width="100%"
        height="100%"
        containerClass="moving-box"
        [options]="lottieOptions"
        (complete)="loopComplete()"
        (animationCreated)="animationCreated($event)"
        (enterFrame)="animationLoaded()"
        (error)="onAnimationError($event)"></ng-lottie>
    </div>
    <div class="animation" *ngIf="switch === 'B'">
      <ng-lottie
        *ngIf="lottieOptions"
        class="lottie-animation"
        width="100%"
        height="100%"
        containerClass="moving-box"
        [options]="lottieOptions"
        (animationCreated)="animationCreated($event)"
        (enterFrame)="animationLoaded()"
        (error)="onAnimationError($event)"></ng-lottie>
    </div>
    <span class="loading" *ngIf="animationLoading">
      <app-spinner class="loading-spinner" [contrast]="true"></app-spinner>
    </span>
    <span class="error" *ngIf="animationError">
      <div class="icon primary" svgIcon="streamline:alert_circle"></div>
    </span>
  </div>
</div>
